import * as R from 'ramda';
import pathIsTruthy from './pathisTruthy';

const pathOrDash = R.curry((path, data) => R.ifElse(pathIsTruthy(path), R.path(path), R.always('--'))(data));

export default pathOrDash;
